<template>
  <div class="container order-list">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>

    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div class="sForm">
        <el-form :inline="true" id="searchForm" label-width="70px">
          <el-form-item label="商品名称" prop="orderNo">
            <el-input v-model.trim="searchForm.goodsName" size="small" placeholder="请输入商品名称" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="下单用户" prop="userInfo">
            <el-input v-model.trim="searchForm.userInfo" size="small" placeholder="请输入下单用户" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="收货人" prop="postUserInfo">
            <el-input v-model.trim="searchForm.postUserInfo" size="small" placeholder="收货人信息" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input v-model.trim="searchForm.orderNo" size="small" placeholder="请输入订单编号" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="售后编号" prop="afterNo">
            <el-input v-model.trim="searchForm.afterNo" size="small" placeholder="请输入售后编号" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="售后类型" prop="orderType">
            <el-select v-model="searchForm.afterType" placeholder="请选择售后类型" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_after_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="售后状态" prop="orderType">
            <el-select v-model="searchForm.afterStatus" placeholder="请选择售后状态" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_after_status" :key="item.dictId"
                :label="item.dictName" :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间" prop="createdTime">
            <el-date-picker v-model="searchForm.createdTime" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单类型" prop="orderType">
            <el-select v-model="searchForm.orderType" placeholder="请选择订单类型" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="small" @click="fetchData('search')"
              @keyup.enter="fetchData('search')">查询</el-button>
            <el-button type="primary" plain size="small" @click="fetchData('reset')">重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="btn-list tabclass">
        <h3>数据列表</h3>
        <div>
          <el-button type="primary" :loading="exportLoading" icon="el-icon-upload2" @click="lotsExport">批量导出</el-button>
        </div>
      </div>
      <orders-list-table :dataList="page.list" :heightStr="columns.height" :config="columnCommon.config"
        typeStr="afterOrder" @tableSelectionChange="handleSelectionChange"></orders-list-table>
      <!-- 分页start -->
      <div class="page">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="page.pageNo" :page-sizes="[3, 5, 10, 20, 50]" :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="page.totalNum">
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import ordersListTable from '../components/ordersListTable'
export default {
  components: {
    ordersListTable,
    breadcrumbTop,
    breadcrumbSearch
  },
  data() {
    return {
      radio1: '0',
      searchList: {
        list: [
          { title: '售后订单', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      dataList: {
        list: [
          { title: '订单管理', path: '', type: '0' },
          { title: '售后订单', path: '', type: '1' }
        ]
      },
      exportLoading: false,
      loadingState: false,
      loadingStateTwo: false,
      loadingStateThree: false,
      loadingStateFour: false,
      loading: false,
      parArray: [],
      userType: '',
      columns: {
        type: 'all',
        height: '5000px',
        sortObj: {},
        config: []
      },
      // 公共  column
      columnCommon: {
        type: 'common',
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { type: 'selection', width: 50 },
          { prop: 'no', label: '售后编号', width: 150, slot: 'no' },
          // { prop: 'remarks', label: '售后编号', width: 100, slot: 'no' },
          { prop: 'payTypeLabel', label: '商品信息', width: 300, slot: 'info' },
          { prop: 'user', label: '下单用户', width: 120, slot: 'user' },
          { prop: 'post', label: '收货人', width: 120, slot: 'post' },
          // { prop: 'postDetailedAddress', label: '收货地址', width: 140 },
          { prop: 'refundMoney', label: '退款金额(元)', width: 80, slot: 'refundMoney' },
          { prop: 'createdTime', label: '申请时间', width: 150, },
          { prop: 'afterTypeLabel', label: '售后类型', width: 100 },
          { prop: 'afterReasonLabel', label: '售后原因', width: 100, },
          { prop: 'statusLabel', label: '售后状态', width: 100, slot: 'status' },
          {
            prop: 'approveRemark', label: '备注', width: 150, slot: 'approveRemark'
          },
          {
            prop: 'remarks', label: '操作', width: 120, align: 'center'
          }
        ]
      },
      multipleSelection: '', // 多选
      cancelOrderId: '', // 取消订单id
      setCloseOrder: '', // 取消订单参数
      statusCount: {
        waitingSubmitCount: 0, // 提交订单前 待提交
        closedCount: 0, // 已关闭数量
        finishedCount: 0, // 已完成数量
        prePostCount: 0, // 待发货数量
        preReceivedCount: 0, // 待签收数量
        processCount: 0, // 审核中数量
        totalCount: 0 // 全部数量
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        goodsName: null,
        userInfo: null,
        postUserInfo: null,
        orderNo: null,
        afterNo: null,
        afterType: null,
        afterStatus: null,
        approveTimeStart: null,
        approveTimeEnd: null,
        orderType: null
      },
      currentTab: '', // 当前列表状态
      // 分配状态
      currentTabStatus: {
        all: '', // 全部
        beforePay: 1, // 待支付
        choicing: 2, // 备货中
        signFor: 3, // 待签收
        accomplish: 4, // 已完成
        afterSale: 6 // 已关闭
      },
      columnTitle: this.column,
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: ''
          },
          {
            title: '运营订单',
            type: '1',
            path: ''
          }

        ]
      },
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      rQuery: {},
      afterSale: '',
      dictionaries: {
        platform_order_type: [],
        platform_order_after_type: [],
        platform_order_after_status: []
      }
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {

      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.getDictionaries('platform_order_type')
    this.getDictionaries('platform_order_after_type')
    this.getDictionaries('platform_order_after_status')
    this.fetchData()
    // this.$forceUpdate()
    // this.initSearchList()// 初始化，搜索需要的列表数据
  },
  mounted() {
    // this.$nextTick(_ => {
    //   const rQuery = this.rQuery
    //   if (rQuery.state) {
    //     this.onChangeCurrentTab(Number(rQuery.state))
    //     this.currentTab = rQuery.state || ''
    //   } else {
    //     this.onChangeCurrentTab() // fetchData 在这里执行
    //   }
    //   console.log('this.currentTab = ', this.currentTab)
    // })
  },
  methods: {
    //批量导出
    lotsExport() {
      let ids = []
      if (this.multipleSelection) {
        this.multipleSelection.forEach(item => {
          ids.push(item.id)
        })
      }

      this.exportLoading = true
      this.searchForm.ids = ids
      this.axios.post('/orders/after/export', this.searchForm).then(res => {
        if (res.code == 0) {
          this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    onChangeCurrentTab(status) {
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
      let strTemp = 'all'
      let configTemp = [...this.columnCommon.config]
      this.columns.type = strTemp
      this.columns.config = Array.from(new Set(configTemp))
      this.fetchData('search')
    },
    fetchData(type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {

        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.axios.post('/orders/after/pageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        } else {
          console.log('goodsPageList - 失败', type)
        }
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
      console.log(currentChange, 'currentChange')
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageNo = 1
      this.page.currentPage = 1
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },

    // 订单数量统计查询
    getStatusCount(params) {
      // const params = {}
      this.$api.getStatusCount(params).then((res) => {
        this.statusCount = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 初始化，搜索需要的列表数据
    initSearchList() {
      const params = { pageNo: 1, pageSize: 1001 }
      // this.getPlatformDataList(params) // 平台
      // this.getShopDataList(params) // 店铺
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style scoped lang="scss">
.sForm {
  .el-input {
    width: 232px !important;
  }

  .el-select {
    width: 232px !important;
  }

  .el-range-editor {
    width: 232px !important;
  }
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.page {
  text-align: right;
  margin: 10px auto;
}

/deep/ .hide-content {
  display: none !important;
}

/deep/ .show-content {
  display: inline-block;
}

/deep/ .el-link {
  margin: 0 5px;
}

.search-form .el-form-item {
  width: 100%;
  // max-width: 295px;
  width: 250px;
  margin-right: 10px;

  .el-date-picker {
    width: 250px;
  }
}

/deep/ .el-table th>.cell,
/deep/ .el-table td {
  text-align: unset;
}

.tabclass {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.yellowBtn,
.blueBtn,
.serviceDerive,
.promotionDerive {
  height: 36px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.yellowBtn {
  //width: 160px;
  //height: 36px;
  background: #edb840;
  //border-radius: 4px;
}

.blueBtn {
  //width: 120px;
  //height: 36px;
  background: #4168e7;
  //border-radius: 4px;
}

.serviceDerive {
  //width: 160px !important;
  background: #67c23a !important;
}

.promotionDerive {
  //width: 160px !important;
  background: #e6a23c !important;
}

.serviceDeriveTwo {
  //width: 160px !important;
  background: #0f82c5 !important;
}

.promotionDeriveTwo {
  //width: 160px !important;
  background: #b705fd !important;
}

.tabBtn {
  //width: 100px;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  margin-bottom: 10px;
}

/deep/ .el-tabs {
  margin-top: 20px;

  .el-tabs__header {
    .el-tabs__nav-wrap {
      .el-tabs__nav-scroll {
        padding: 0;

        .el-tabs__nav {
          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__item {
            margin-right: 20px;
            width: 120px;
            height: 36px;
            padding: 0;
            text-align: center;
            line-height: 36px;
            font-size: 16px;
            color: #999999;
            border-radius: 4px;
            background: #ececec;
          }

          .el-tabs__item.is-active {
            color: #333333;
            background: #e3edff;
          }
        }
      }
    }
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }
}

.shopTitle {
  margin-bottom: 20px;
}

// /deep/ .el-button {
//   border: none;
// }

.search-form {
  .el-form-item {
    max-width: 312px;

    /deep/ .el-form-item__label {
      width: 100px;
    }

    /deep/ .el-form-item__content {
      width: calc(100% - 100px);

      // .el-date-editor {
      //   //width: calc(100% - 82px);
      // }
    }
  }
}

.orderNotes {
  margin-top: 24px;
  padding-bottom: 25px;
  border-bottom: 1px solid #d9d9d9;

  .headerOrder {
    .orderRemak {
      margin-bottom: 12px;
      font-size: 18px;
    }
  }
}

/deep/ .el-textarea__inner {
  height: 132px;
}

.statistics {
  margin-top: 30px;
  display: flex;
  justify-content: right;
  align-items: center;

  .fourteen {
    font-size: 14px;
    padding-right: 20px;
  }

  .blue {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #4168e7;
  }
}

.present {
  display: flex;
  justify-content: right;
  height: 36px;
  margin-top: 30px;
  padding-bottom: 28px;
}

.tabsBtn {
  display: flex;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell p {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

/*
/deep/.el-table__row td .cell span, /deep/.el-table__row td .cell div p{
  display: block;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
*/
/deep/ .el-scrollbar {
  height: 10px;
}

/deep/ .el-scrollbar__bar.is-horizontal {
  height: 9px;
}

::v-deep .el-form-item__label {
  padding: 0px 10px 0 0;
}
</style>